import { render, staticRenderFns } from "./ControlHolder.vue?vue&type=template&id=105f2ca4&scoped=true&"
import script from "./ControlHolder.vue?vue&type=script&lang=js&"
export * from "./ControlHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f2ca4",
  null
  
)

export default component.exports